import { useMemo, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordInput({
  className = "",
  style,
  wrapperClassName = "relative",
  wrapperStyle,
  buttonClassName = "absolute inset-y-0 right-0 inline-flex items-center px-3 text-zinc-500 hover:text-zinc-700 focus:outline-none",
  buttonStyle,
  showLabel = "Show password",
  hideLabel = "Hide password",
  ...inputProps
}) {
  const [visible, setVisible] = useState(false);

  const mergedStyle = useMemo(() => {
    if (!style) return style;
    return {
      ...style,
      paddingRight: style.paddingRight ?? 38,
    };
  }, [style]);

  return (
    <div className={wrapperClassName} style={wrapperStyle}>
      <input
        {...inputProps}
        type={visible ? "text" : "password"}
        className={className ? `${className} pr-10` : className}
        style={mergedStyle}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? hideLabel : showLabel}
        className={buttonClassName}
        style={buttonStyle}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
